"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var columnFiltersSlice_1 = __importDefault(require("./columnFiltersSlice"));
var rootReducer = redux_1.combineReducers({
    filters: columnFiltersSlice_1.default,
});
exports.default = rootReducer;
